var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"splash",class:{ 'fade-out': !_vm.visible, 'fade-in': _vm.visible }},[_c('div',{staticClass:"logo"})])
}
var staticRenderFns = []

export { render, staticRenderFns }